:host {
  .message-event {
    .message-event-title {
      color: #333;
      color: var(--font-primary);
      font-size: 15px;
      letter-spacing: 0;

      img {
        margin-right: 5px;
        filter: invert(54%) sepia(36%) saturate(3926%) hue-rotate(2deg) brightness(104%)
          contrast(107%);
        filter: var(--icon-orange);
      }
    }
    .message-event-list {
      .event-description {
        color: #666666;
        color: var(--font-secondary);
        font-size: 15px;
        letter-spacing: 0;
        margin-bottom: 20px;
      }

      .event-action {
        a {
          display: inline-block;
          text-decoration: none;
          color: white;
          padding: 10px 15px;
          border: 1px solid #0098ff;
          border-radius: 6px;
          background-color: #0098ff;

          &:hover {
            transition: 0.3s;
            background: #007ee2;
            background: var(--blue-hover);
            color: white;
          }
        }
      }
    }
  }
}
